/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-sequences */

import React, { useState, useEffect } from "react";
import { Row, Col, Label, Button, InputGroup } from "reactstrap";

import Select from "react-select";

import TextareaAutosize from "react-textarea-autosize";

import { isFunction } from "../../Libs/CustomMethods/customMethods";

const CustomFormRepeater = ({
  onChange,
  onChangeSelect,
  value,
  fields,
  ...props
}) => {
  let initialValues = Array.isArray(fields)
    ? fields
        .map((element) => element.name)
        .reduce((a, b) => ((a[b] = undefined), a), {})
    : [];

  const [inputValues, setInputValues] = useState(initialValues);

  const [selectValue, setSelectValue] = useState(undefined);

  const [error, setError] = useState(false);

  useEffect(() => {
    if (error)
      setTimeout(() => {
        setError(false);
      }, 2000);
  }, [error]);

  useEffect(() => {
    if (selectValue) {
      isFunction(onChangeSelect) && onChangeSelect(selectValue);
    }
  }, [selectValue]);

  const handleAdd = (e) => {
    onChange([e, ...value]);
    setInputValues(initialValues);
  };

  const handleDelete = (e) => {
    onChange(value.filter((item) => item !== e));
  };

  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  return (
    <React.Fragment>
      <div>
        <Row {...props.inputRowProps}>
          <Col {...props.inputColProps}>
            <Row>
              {fields &&
                fields.map((element, key) => (
                  <Col {...element.colProps} key={key}>
                    <Label {...element.labelProps}>
                      {element.label && capitalizeFirstLetter(element.label)}
                    </Label>
                    {element?.select ? (
                      <Select
                        onChange={(e) => {
                          setSelectValue({
                            ...selectValue,
                            [element.name]: e,
                          });
                          let value;
                          if (element?.inputProps?.isMulti) {
                            value = e ? e.map((e) => e.value) : undefined;
                          } else {
                            value = e ? e.value : undefined;
                          }
                          setInputValues({
                            ...inputValues,
                            [element.name]: value,
                          });
                        }}
                        value={
                          selectValue && selectValue[element.name]
                            ? selectValue[element.name]
                            : null
                        }
                        {...element.inputProps}
                      />
                    ) : element?.textarea ? (
                      <div className="d-flex">
                        <TextareaAutosize
                          type="textarea"
                          {...element.inputProps}
                          onChange={(e) => {
                            setInputValues({
                              ...inputValues,
                              [element.name]: e.target.value,
                            });
                          }}
                          defaultValue={inputValues[element.name] ?? ""}
                        />
                        <div id="textCopy"></div>
                      </div>
                    ) : (
                      <InputGroup>
                        <input
                          {...element.inputProps}
                          onChange={(e) => {
                            setInputValues({
                              ...inputValues,
                              [element.name]: e.target.value,
                            });
                          }}
                          value={inputValues[element.name] ?? ""}
                        />
                        {element.percentIcon && (
                          <span className="input-group-append">
                            <span className="input-group-text">%</span>
                          </span>
                        )}
                      </InputGroup>
                    )}
                  </Col>
                ))}
            </Row>
          </Col>
          <Col {...props.buttonColProps}>
            <Label {...props.actionLabelProps}>{props.actionLabel}</Label>
            <Button
              disabled={props?.active ? props?.active : false}
              {...props.addButtonProps}
              onClick={() => {
                if (!Object.values(inputValues).some((e) => !e)) {
                  setError(false);
                  handleAdd(inputValues);
                  setSelectValue(null);
                } else {
                  setError(true);
                }
              }}
            >
              {props.addButtonText}
            </Button>
          </Col>
          <Col
            sm="12"
            className={error ? "text-danger text-center my-3" : "d-none"}
          >
            {error && props.errorText}
          </Col>
        </Row>
      </div>

      {value &&
        value.length > 0 &&
        value.map((item, key) => (
          <Row {...props.outputRowProps} key={key}>
            <Col {...props.outputColProps}>
              <Row>
                {fields &&
                  fields.map((element, key) => (
                    <Col {...element.colProps} key={key}>
                      {props.outputTextArea && !element?.select ? (
                        <div className="d-flex">
                          <TextareaAutosize
                            type="textarea"
                            {...props.outputProps}
                            value={item[element.name]}
                            disabled
                          />
                          <div id="textCopy"></div>
                        </div>
                      ) : (
                        <InputGroup>
                          {element.group ? (
                            <input
                              {...props.outputProps}
                              value={item[element.name].name}
                              disabled
                            />
                          ) : (
                            <input
                              {...props.outputProps}
                              value={item[element.name]}
                              disabled
                            />
                          )}
                          {element.percentIcon && (
                            <span className="input-group-append">
                              <span className="input-group-text">%</span>
                            </span>
                          )}
                        </InputGroup>
                      )}
                    </Col>
                  ))}
              </Row>
            </Col>
            <Col {...props.buttonColProps}>
              <Button
                {...props.deleteButtonProps}
                onClick={() => {
                  handleDelete(item);
                }}
              >
                {props.deleteButtonText}
              </Button>
            </Col>
          </Row>
        ))}
    </React.Fragment>
  );
};

export default CustomFormRepeater;
